import { SharedTradeInterface } from '../ng-services/social-trading/trade-sharing.store';

export function getSharedTradeStrategy(trade: SharedTradeInterface) {
    return trade.setup_file?.setup?.EntryStrategy?.Name;
}
